import DOMPurify from 'dompurify';

export const Sanitize = ({ html }: any) => {
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p',
      'span',
      'div',
      'strong',
      'em',
      'b',
      'i',
      'u',
      'br',
      'ul',
      'ol',
      'li',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
    ],
    ALLOWED_ATTR: ['class'],
  });

  return <div className="sanitized-html" dangerouslySetInnerHTML={{ __html: clean }} />;
};
